import { currentPage } from '../common/layout';
// import { getCBSWidget } from '../common/shop/cbs-widget-loader';
import { updateShortDescriptionBox } from '../common/short-description';
import {
  getM1FindVehicleEu,
  getM1FindVehicleUs,
  getM1FindVehicleByType,
} from '../common/shop/m1-find-vehicle-widget-loader';
// import '../common/jquery.sticky';
import '../common/msnt/msnt-lightslider.js';
import '../common/jquery-snap-scroll';
import '../common/short-description';
// import '../common/lazyload.picture';

currentPage.pageInit = ($page, pageData, pageId) => {
  const dataEdtn = document.querySelector('body').dataset.edtn;
  $('.msnt-items-slider').snapScrollControl();
  getM1FindVehicleEu().then((api) => {
    api.m1FindVehicleEu();
  });
  getM1FindVehicleUs().then((api) => {
    api.m1FindVehicleUs();
  });
  getM1FindVehicleByType().then((api) => {
    api.m1FindVehicleByType();
  });

  // if (currentEdition == 'us' || currentEdition == 'ev_us') {
  //   getCBSWidget().then((api) => {
  //     api.cbsWidget();
  //   });
  // }

  updateShortDescriptionBox();
  window.addEventListener('resize', updateShortDescriptionBox);
};
